import {Authority} from '@/shared/security/authority'

export const parametrage = {
  thematiques: {
    autorisationConstruire: {
      icon: 'fas fa-folder-open',
      dossiers: [
        {type: 'APA', roles: []},
        {type: 'MPA', roles: []},
        {type: 'DD', roles: []},
        {type: 'M', roles: []},
        {type: 'DP', roles: []},
        {type: 'DR', roles: [Authority.COLLABORATEURS_OAC]},
        {type: 'PFED', roles: [Authority.COLLABORATEURS_OAC]},
        {type: 'SEPARATEUR_LISTE', roles: []},
        {type: 'APAT', roles: []},
        {type: 'APL', roles: []},
        {type: 'EAPA', roles: [Authority.COLLABORATEURS_OAC]},
        {type: 'EDD', roles: [Authority.COLLABORATEURS_OAC]},
        {type: 'EDP', roles: [Authority.COLLABORATEURS_OAC]},
        {type: 'EDR', roles: [Authority.COLLABORATEURS_OAC]},
        {type: 'ELER', roles: [Authority.COLLABORATEURS_OAC]},
        {type: 'EM', roles: [Authority.COLLABORATEURS_OAC]},
        {type: 'LER', roles: []},
        {type: 'LER-PA', roles: []},
        {type: 'LER-PAT', roles: []}
      ],
      statuts: ['DEPOSE', 'EN_INSTRUCTION', 'EN_SYNTHESE', 'DECIDE', 'SUIVI_CHANTIER', 'MISE_EN_SERVICE', 'FIN_DOSSIER']
    },
    ventesAppartements: {
      icon: 'fas fa-building-user',
      dossiers: [{type: 'VA', roles: []}],
      statuts: ['DEPOSE', 'DECIDE', 'FIN_DOSSIER', 'VA']
    },
    planAffectation: {
      icon: 'fas fa-map',
      dossiers: [
        {type: 'ABRMZ', roles: []},
        {type: 'ABRPLQ', roles: []},
        {type: 'DR', roles: []},
        {type: 'DSOPB', roles: []},
        {type: 'MZ', roles: []},
        {type: 'PAL', roles: []},
        {type: 'PDCOM', roles: [Authority.COLLABORATEURS_OU]},
        {type: 'PDCP', roles: [Authority.COLLABORATEURS_OU]},
        {type: 'PDQ', roles: []},
        {type: 'PDZI', roles: []},
        {type: 'PLCP', roles: []},
        {type: 'PLQ', roles: []},
        {type: 'PRR', roles: []},
        {type: 'PS', roles: []},
        {type: 'PUS', roles: []},
        {type: 'RS', roles: []},
        {type: 'ZAP', roles: []},
        {type: 'ZR', roles: []}
      ],
      statuts: [
        "A L'ENQUETE",
        'ABANDONNE DA',
        'ABROGE',
        'ADOPTE',
        'ANNULE_DA',
        'CADUQUE_DA',
        'EN ATTENTE',
        'EN COURS DA',
        'EN SUSPENS DA',
        'OPPOSITION',
        'PREAVIS CM',
        'RECOURS DA',
        'REFERENDUM',
        'REFUSE_DA',
        'SUPPRIME DA',
        'TERMINE DA',
        'TEST'
      ]
    },
    diversAmenagement: {
      icon: 'fas fa-map-signs',
      dossiers: [
        {type: 'DIV', roles: []},
        {type: 'PEXT', roles: []},
        {type: 'POT', roles: []},
        {type: 'PSEC', roles: []},
        {type: 'UP', roles: []}
      ],
      statuts: [
        "A L'ENQUETE",
        'ABANDONNE DA',
        'ABROGE',
        'ADOPTE',
        'ANNULE_DA',
        'CADUQUE_DA',
        'EN ATTENTE',
        'EN COURS DA',
        'EN SUSPENS DA',
        'OPPOSITION',
        'PREAVIS CM',
        'RECOURS DA',
        'REFUSE_DA',
        'SUPPRIME DA',
        'TERMINE DA',
        'TEST'
      ]
    },
    rechercheAvancee: {
      icon: 'fas fa-search'
    }
  },
  date: {
    dateFormatDisplay: 'DD.MM.YYYY',
    dateFormatServer: 'YYYY-MM-DD'
  },
  statuts: [
    'ABANDONNE',
    'ABROGE',
    "A L'ENQUETE",
    'ACCEPTE',
    'ADOPTE',
    'ARCHANT',
    'ARCHIVE',
    'CADUQUE',
    'CHANTIER',
    'DECIDE',
    'EDISCAN',
    'EN COURS',
    'EN SUSPENS',
    'EN SUSPENS DA',
    'ENREGISTRE',
    'ENREGISTREMENT',
    'GC',
    'INSTRUCTION',
    'OPPOSITION',
    'ORMIG',
    'PREAVIS CM',
    'PROCEDURE AMS',
    'REALISE',
    'RECOURS',
    'RECOURS DA',
    'REFERENDUM',
    'REFUS ENTREE',
    'REFUSE',
    'RENVOYE',
    'TERMINE',
    'VA',
    'EN_PREPARATION',
    'DEPOSE',
    'EN_INSTRUCTION',
    'EN_SYNTHESE',
    'DECIDE',
    'SUIVI_CHANTIER',
    'MISE_EN_SERVICE',
    'FIN_DOSSIER',
    'ANNULE'
  ],
  communes: [
    {id: 1, nom: 'Aire-la-Ville', codePreaviseur: 'Commune_A.V.', region: ['PA_1', 'PO_2'], numero: 1},
    {id: 2, nom: 'Anières', codePreaviseur: 'Commune_An', region: ['PA_1', 'PO_2'], numero: 2},
    {id: 3, nom: 'Avully', codePreaviseur: 'Commune_Al', region: ['PA_1', 'PO_2'], numero: 3},
    {id: 4, nom: 'Avusy', codePreaviseur: 'Commune_As', region: ['PA_1', 'PO_2'], numero: 4},
    {id: 5, nom: 'Bardonnex', codePreaviseur: 'Commune_Ba', region: ['PA_1', 'PO_2'], numero: 5},
    {id: 6, nom: 'Bellevue', codePreaviseur: 'Commune_Bl', region: ['PA_1', 'PO_1'], numero: 6},
    {id: 7, nom: 'Bernex', codePreaviseur: 'Commune_Bx', region: ['PA_1', 'PO_2'], numero: 7},
    {id: 8, nom: 'Carouge', codePreaviseur: 'Commune_Ca', region: ['PA_1', 'PO_2'], numero: 8},
    {id: 9, nom: 'Cartigny', codePreaviseur: 'Commune_Ct', region: ['PA_1', 'PO_2'], numero: 9},
    {id: 10, nom: 'Céligny', codePreaviseur: 'Commune_Ce', region: ['PA_1', 'PO_1'], numero: 10},
    {id: 11, nom: 'Chancy', codePreaviseur: 'Commune_Cy', region: ['PA_1', 'PO_2'], numero: 11},
    {id: 12, nom: 'Chêne-Bougeries', codePreaviseur: 'Commune_C.Bs', region: ['PA_1', 'PO_2'], numero: 12},
    {id: 13, nom: 'Chêne-Bourg', codePreaviseur: 'Commune_C.Bg', region: ['PA_1', 'PO_2'], numero: 13},
    {id: 14, nom: 'Choulex', codePreaviseur: 'Commune_Ch', region: ['PA_1', 'PO_2'], numero: 14},
    {id: 15, nom: 'Collex-Bossy', codePreaviseur: 'Commune_Cx', region: ['PA_1', 'PO_1'], numero: 15},
    {id: 16, nom: 'Collonge-Bellerive', codePreaviseur: 'Commune_C.Be', region: ['PA_1', 'PO_2'], numero: 16},
    {id: 17, nom: 'Cologny', codePreaviseur: 'Commune_Co', region: ['PA_1', 'PO_2'], numero: 17},
    {id: 18, nom: 'Confignon', codePreaviseur: 'Commune_Cn', region: ['PA_1', 'PO_2'], numero: 18},
    {id: 19, nom: 'Corsier', codePreaviseur: 'Commune_Cr', region: ['PA_1', 'PO_2'], numero: 19},
    {id: 20, nom: 'Dardagny', codePreaviseur: 'Commune_Da', region: ['PA_1', 'PO_1'], numero: 20},
    {id: 21, nom: 'Genève-Cité', codePreaviseur: 'Commune_Ge', region: ['PA_1', 'PO_1', 'PO_2'], numero: 21},
    {id: 22, nom: 'Genève-Eaux-Vives', codePreaviseur: 'Commune_Ge', region: ['PA_1', 'PO_2'], numero: 22},
    {id: 23, nom: 'Genève-Petit-Saconnex', codePreaviseur: 'Commune_Ge', region: ['PA_1', 'PO_1'], numero: 23},
    {id: 24, nom: 'Genève-Plainpalais', codePreaviseur: 'Commune_Ge', region: ['PA_1', 'PO_2'], numero: 24},
    {id: 25, nom: 'Genthod', codePreaviseur: 'Commune_Gd', region: ['PA_1', 'PO_1'], numero: 25},
    {id: 26, nom: 'Grand-Saconnex', codePreaviseur: 'Commune_G.S.', region: ['PA_1', 'PO_1'], numero: 26},
    {id: 27, nom: 'Gy', codePreaviseur: 'Commune_Gy', region: ['PA_1', 'PO_2'], numero: 27},
    {id: 28, nom: 'Hermance', codePreaviseur: 'Commune_He', region: ['PA_1', 'PO_2'], numero: 28},
    {id: 29, nom: 'Jussy', codePreaviseur: 'Commune_Ju', region: ['PA_1', 'PO_2'], numero: 29},
    {id: 30, nom: 'Laconnex', codePreaviseur: 'Commune_Lx', region: ['PA_1', 'PO_2'], numero: 30},
    {id: 31, nom: 'Lancy', codePreaviseur: 'Commune_Ly', region: ['PA_1', 'PO_2'], numero: 31},
    {id: 32, nom: 'Meinier', codePreaviseur: 'Commune_Mr', region: ['PA_1', 'PO_2'], numero: 32},
    {id: 33, nom: 'Meyrin', codePreaviseur: 'Commune_Mn', region: ['PA_1', 'PO_1'], numero: 33},
    {id: 34, nom: 'Onex', codePreaviseur: 'Commune_Ox', region: ['PA_1', 'PO_2'], numero: 34},
    {id: 35, nom: 'Perly-Certoux', codePreaviseur: 'Commune_P.C.', region: ['PA_1', 'PO_2'], numero: 35},
    {id: 36, nom: 'Plan-les-Ouates', codePreaviseur: 'Commune_P.L.O.', region: ['PA_1', 'PO_2'], numero: 36},
    {id: 37, nom: 'Pregny-Chambésy', codePreaviseur: 'Commune_Py', region: ['PA_1', 'PO_1'], numero: 37},
    {id: 38, nom: 'Presinge', codePreaviseur: 'Commune_Pr', region: ['PA_1', 'PO_2'], numero: 38},
    {id: 39, nom: 'Puplinge', codePreaviseur: 'Commune_Pu', region: ['PA_1', 'PO_2'], numero: 39},
    {id: 40, nom: 'Russin', codePreaviseur: 'Commune_Ru', region: ['PA_1', 'PO_1'], numero: 40},
    {id: 41, nom: 'Satigny', codePreaviseur: 'Commune_Sy', region: ['PA_1', 'PO_1'], numero: 41},
    {id: 42, nom: 'Soral', codePreaviseur: 'Commune_Sl', region: ['PA_1', 'PO_2'], numero: 42},
    {id: 43, nom: 'Thônex', codePreaviseur: 'Commune_Th', region: ['PA_1', 'PO_2'], numero: 43},
    {id: 44, nom: 'Troinex', codePreaviseur: 'Commune_Tr', region: ['PA_1', 'PO_2'], numero: 44},
    {id: 45, nom: 'Vandoeuvres', codePreaviseur: 'Commune_Va', region: ['PA_1', 'PO_2'], numero: 45},
    {id: 46, nom: 'Vernier', codePreaviseur: 'Commune_Vn', region: ['PA_1', 'PO_1'], numero: 46},
    {id: 47, nom: 'Versoix', codePreaviseur: 'Commune_Vs', region: ['PA_1', 'PO_1'], numero: 47},
    {id: 48, nom: 'Veyrier', codePreaviseur: 'Commune_Vy', region: ['PA_1', 'PO_2'], numero: 48}
  ],
  cartographie: {
    urlImageParcelle: 'https://www.etat.ge.ch/geoportail/ImageParcelle/img.ashx?Id=##REQUETE_PARCELLE##&m=ortho&z=2',
    urlCarteInteractive: 'https://map.sitg.ge.ch/?locparcelle=##REQUETE_PARCELLE##&mapresources=CADASTRE'
  },
  fao: {
    urlAvis: 'https://fao.ge.ch/avis/'
  },
  originesDossier: {
    ACDEMAT: 'AC-DEMAT',
    SAD: 'SAD',
    SYNTHURBA: 'SYNT'
  },
  etapesLdv: {
    circulation: 'CIRCULATION'
  },
  valeurDecision: {
    autorisation: 'AUTORISATION',
    apat: 'APAT',
    avenant: 'AVENANT',
    avenantApat: 'AVENANT_APAT'
  },
  prolongation: {
    autorisation: 'Autorisation',
    prolongationConfirmee: 'Prolongation confirmée'
  },
  recours: {
    autorisationConfirmee: 'Autorisation confirmée',
    codeObjet: {
      decision: 'DEC',
      prolongation: 'PRO'
    }
  },
  separateurListe: {
    text: '------',
    value: 'SEPARATEUR_LISTE',
    oac: {
      text: '--- OAC ---',
      value: 'SEPARATEUR_LISTE_OAC'
    },
    ou: {
      text: '--- OU ---',
      value: 'SEPARATEUR_LISTE_OU'
    },
    va: {
      text: '--- VA ---',
      value: 'SEPARATEUR_LISTE_VA'
    }
  }
}
